import { Base } from "../../framework/base";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "./recordFurtherEducationGroupNode";

export interface IRecordCompanyFurtherEducationGroups {
    companyId: string;
    companyName: string;
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
}

export class RecordCompanyFurtherEducationGroups implements IRecordCompanyFurtherEducationGroups {
    companyId: string;
    companyName: string;
    furtherEducationGroups: RecordFurtherEducationGroupNode[];

    constructor();
    constructor(obj: IRecordCompanyFurtherEducationGroups);
    constructor(obj?: any) {
        this.companyId = obj && obj.companyId || "";
        this.companyName = obj && obj.companyName || "";
        this.furtherEducationGroups = Base.getTypedArray(obj ? obj.furtherEducationGroups : null, RecordFurtherEducationGroupNode);
    }

    static equalIdsInFurtherEducationGroups(a: IRecordCompanyFurtherEducationGroups[], b: IRecordCompanyFurtherEducationGroups[]): boolean {
        if (!a || !b) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            const aItem = a[i];
            const bItem = b.find(j => j.companyId === aItem.companyId);
            if (!bItem) return false;
            if (!Base.equalStrArrays(RecordFurtherEducationGroupNode.getAsList(aItem.furtherEducationGroups).map(i => i.id), RecordFurtherEducationGroupNode.getAsList(bItem.furtherEducationGroups).map(i => i.id))) return false;
        };
        return true;
    };
}